// The route-request selection contract between the OnlineApp and the Nav.
//
// When the web OnlineApp resolves a URL to a nav option (deep link, back/forward, in-app
// navigation), it fires this event on the nav option's DOM element
// (OnlineAppNavOption#fireSelectedWithRouteRequestEvent); the Nav's PaneOptionComponent
// listens and selects the matching option in the nav UI.
//
// Lives in constants/ (same discipline as nav_events.js) so the Nav side can listen for it
// WITHOUT importing the OnlineAppNavOption module. That import previously dragged the entire
// online-app state machine into the nav pack (online_app_nav_option → OnlineAppComponent →
// the SM instance), shipping ~14KB of dead online-app code — and a side-effect-instantiated
// StateMachine — into the native apps' Nav webview. Unlike nav_events.js this is a
// same-document, same-repo contract: the native apps do not consume this string.
export const NAV_OPTION_SELECTED_WITH_ROUTE_REQUEST_EVENT =
  "OnlineAppNavOption:SelectedWithRouteRequest";
